import { cva } from 'class-variance-authority';

export const spinnerVariants = cva(
  // Base styles
  [
    'inline-block',
    'rounded-full',
    'border-2',
    'border-current',
    'border-t-transparent',
    'animate-spin',
  ],
  {
    variants: {
      size: {
        sm: ['h-4', 'w-4'],
        md: ['h-6', 'w-6'],
        lg: ['h-8', 'w-8'],
        xl: ['h-12', 'w-12'],
      },
      color: {
        primary: ['text-primary-600'],
        secondary: ['text-secondary-600'],
        white: ['text-white'],
        gray: ['text-gray-500'],
      },
    },
    defaultVariants: {
      size: 'md',
      color: 'primary',
    },
  }
);
